import custom from './custom.json';
import translation from './translation.json';

export default { ...translation, ...custom };